export const TASK_PRIORITIES = ['URGENT', 'HIGH', 'MEDIUM', 'LOW'] as const;

export type TaskPriority = (typeof TASK_PRIORITIES)[number];

/**
 * Highest first, and again the array is the order -- the server sorts by this
 * same ranking in Node for the same reason it is written out here.
 */
export const TASK_PRIORITY_LABELS: Record<TaskPriority, string> = {
  URGENT: 'Urgent',
  HIGH: 'High',
  MEDIUM: 'Medium',
  LOW: 'Low',
};

/**
 * A dot rather than a filled pill. Status is already a pill, and two pills per
 * row reads as a colour chart; a dot carries the same information at a glance
 * without competing with it.
 */
export const TASK_PRIORITY_DOT_CLASSES: Record<TaskPriority, string> = {
  URGENT: 'bg-red-500',
  HIGH: 'bg-orange-400',
  MEDIUM: 'bg-sky-400',
  LOW: 'bg-stone-300',
};

export function isTaskPriority(value: string | null): value is TaskPriority {
  return value !== null && (TASK_PRIORITIES as readonly string[]).includes(value);
}

/**
 * The next priority when the row's priority cell is clicked.
 *
 * Escalates -- LOW -> MEDIUM -> HIGH -> URGENT -- because "bump this up" is what
 * anyone reaching for it means, and wraps, so four clicks always land back where
 * they started and nothing is ever stuck at the top.
 *
 * Walks TASK_PRIORITIES *backwards* for that: the array is ordered highest
 * first, so escalating is a step towards index 0.
 */
export function nextTaskPriority(priority: TaskPriority): TaskPriority {
  const index = TASK_PRIORITIES.indexOf(priority);
  return TASK_PRIORITIES[(index - 1 + TASK_PRIORITIES.length) % TASK_PRIORITIES.length]!;
}
